import React, { FC } from 'react';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import WizardContent from '~/layouts/WizardContent';
import features from '~/constants/features';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import { ScreeningRejectImg } from '~/img';
import theme from '~/constants/theme';

const ScreeningReject: FC = () => {
  const { t } = useTranslation('stageResult');

  return (
    <WizardContent
      content={
        <Container className="ScreeningReject">
          <div className="ScreeningReject-Content">
            <ScreeningRejectImg className="ScreeningReject-ScreeningRejectImg" />
            <Typography.Title className="ScreeningReject-Title">
              {t('We are sorry to say that your application has not been successful this time')}
            </Typography.Title>
            <Typography.Paragraph className="ScreeningReject-Paragraph">
              <Trans t={t} i18nKey="If you wish to discuss with us, please <1>contact us</1>.">
                {'If you wish to discuss with us, please '}
                <a href={features.contactUsLinkScreeningDecline} target="__blank">
                  contact us
                </a>
                .
              </Trans>
            </Typography.Paragraph>
          </div>
          <div className="ScreeningReject-ContactUs">
            <BottomLeftActions contactUsUrl={features.contactUsLinkScreeningDecline} contactUsTextPosition="left" />
          </div>
        </Container>
      }
    />
  );
};

const Container = styled.div`
  .ScreeningReject-Content {
    position: relative;
    .ScreeningReject-ScreeningRejectImg {
      width: 100%;
      margin-bottom: 32px;
    }
    .ScreeningReject-Title {
      position: absolute;
      top: 25%;
      left: 5%;
      width: 40%;
    }
    .ScreeningReject-Paragraph {
      margin-left: 5%;
    }
    @media (max-width: ${theme.breakpoints.md}px) {
      .ScreeningReject-Title {
        position: static;
        width: 100%;
        border-radius: ${theme.borderRadiusBase}px;
      }
      .ScreeningReject-ScreeningRejectImg {
        border-radius: ${theme.borderRadiusBase}px;
      }
      .ScreeningReject-Paragraph {
        margin-left: 0;
      }
    }
  }
  .ScreeningReject-ContactUs {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .ScreeningReject-ContactUs {
      display: none;
    }
  }
`;

export default ScreeningReject;
